// A tab with unsaved work registers a check here; AdminPage asks it before
// switching tabs, following a navbar link or logout, and on browser Back
// (the browser's own leave warning covers reloads and closing).
let check = null;

export const setAdminLeaveGuard = (fn) => {
  check = typeof fn === "function" ? fn : null;
};

export const clearAdminLeaveGuard = (fn) => {
  if (check === fn) check = null;
};

// A message when leaving would drop work, else "".
export const adminLeaveMessage = () => {
  try {
    return String(check?.() ?? "");
  } catch {
    return "";
  }
};

// Browser Back (or Forward) with unsaved work. The router takes a popstate in
// its own window listener and would unmount the admin before any listener
// the admin adds could run, so this one is added when this module loads:
// App.js imports it before the router mounts, which puts it first. It does
// nothing unless AdminPage has set a back handler and there is unsaved work;
// then it stops the router's listener and hands the message to AdminPage,
// which puts the admin URL back and asks. allowNextPop() lets the "Leave"
// replay of Back through.
let backHandler = null;
let passNextPop = false;

export const setAdminBackHandler = (fn) => {
  backHandler = typeof fn === "function" ? fn : null;
};

export const clearAdminBackHandler = (fn) => {
  if (backHandler === fn) backHandler = null;
};

export const allowNextPop = () => {
  passNextPop = true;
};

const onPopState = (event) => {
  if (passNextPop) {
    passNextPop = false;
    return;
  }
  if (!backHandler) return;
  const message = adminLeaveMessage();
  if (!message) return;
  event?.stopImmediatePropagation?.();
  try {
    backHandler(message);
  } catch {
    // a failing handler must never block navigation for good
  }
};

let installed = false;
export const installAdminBackGuard = () => {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("popstate", onPopState, { capture: true });
};

installAdminBackGuard();
